import React from 'react';
import styled from 'styled-components';
import MapImg from '../assets/images/map.jpg';
import PText from './PText';

const MapStyles = styled.div`
  background: url(${MapImg}) no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 400px;
  .container {
    position: relative;
    min-height: 400px;
  }
  .map__card {
    position: absolute;
    right: 20%;
    bottom: 1%;
    padding: 1rem;
    background: var(--deep-dark);
    width: 100%;
    max-width: 250px;
    border-radius: 12px;
  }
  .map__card__heading {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
  .map__card__link {
    display: inline-block;
    font-size: 1.6rem;
    margin-top: 3rem;
    text-decoration: underline;
  }
  @media only screen and (max-width: 768px) {
    background-position: 80% center;
  }
  @media only screen and (max-width: 400px) {
    .map__card {
      max-width: none;
      right: auto;
    }
  }
`;

export default function Map() {
  return (
    <MapStyles>
      <div className="container">
        <div className="map__card">
          <h3 className="map__card__heading">Here I am</h3>
          <PText>Portland, OR, USA</PText>
          <a
            className="map__card__link"
            href="https://www.google.com/maps/place/11947+NW+Tyler+Ct,+Portland,+OR+97229/@45.5465004,-122.8102774,12z/data=!4m6!3m5!1s0x549508ebf87de967:0xd807dcfbba96cb3a!8m2!3d45.5465004!4d-122.7999777!16s%2Fg%2F11c2cqj1gd?entry=ttu"
            target="_blank"
            rel="noreferrer"
          >
            Open in google map
          </a>
        </div>
      </div>
      {/* <img src={MapImg} alt="Map" /> */}
    </MapStyles>
  );
}
